/* @flow */

import { rem } from 'polished';

import { disabledOpacity } from 'src/shared/app/base/style/token/opacity';
import { aaDarkGrey } from '@braindate/ui/lib/token/palette';
import {
  baseFontSize,
  inputFontSize,
  inputFontWeight,
  inputLineHeight,
} from '@braindate/ui/lib/token/typography';

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

const arrowSize = '4px';
const arrowBgSize = rem(16, baseFontSize);

export default {
  select: {
    borderRadius: 0,

    // Remove the inheritance of text transform in Firefox
    textTransform: 'none',

    cursor: 'pointer',
    color: ({ theme }: ThemeFunction) => theme.textColor,

    '&:disabled': {
      pointerEvents: 'none',
    },
    '& option': {
      backgroundColor: ({ theme }: ThemeFunction) => theme.colorBase,
    },
  },
  'input[list]': {
    // Show the overflow in Edge
    overflow: 'visible',
  },
  'select, input[list]': {
    // Remove the margin in Firefox and Safari
    margin: 0,
    padding: [rem(4, baseFontSize), 0],

    backgroundColor: 'transparent',
    backgroundImage: ({ theme }: ThemeFunction) => `
       linear-gradient(45deg, transparent 50%, ${theme.accentColor} 0),
       linear-gradient(135deg, ${theme.accentColor} 50%, transparent 0),
       linear-gradient(90deg, transparent, transparent)`,
    backgroundPosition: `
       calc(100% - ${arrowBgSize} / 2) calc(50%),
       calc(100% - ${arrowBgSize} / 2 + ${arrowSize}) calc(50%),
       100% 0`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: `
       ${arrowSize} ${arrowSize},
       ${arrowSize} ${arrowSize},
       ${arrowBgSize} 100%`,
    border: 'none',
    borderBottom: `solid 2px ${aaDarkGrey}`,
    appearance: 'none',
    // Hide highlight occuring when an input is being tapped on WebKit
    WebkitTapHighlightColor: 'transparent',

    // Change the font styles in all browsers
    fontFamily: 'inherit',
    fontSize: rem(inputFontSize, baseFontSize),
    fontWeight: inputFontWeight,
    lineHeight: inputLineHeight / inputFontSize,

    '&:focus': {
      borderColor: ({ theme }: ThemeFunction) => theme.accentColor,
      outlineWidth: 0,
    },
    '&:disabled': {
      opacity: disabledOpacity,
    },

    '&::-webkit-calendar-picker-indicator': {
      // Hide arrow of the list input in Webkit
      opacity: 0,
    },
    '&::-ms-expand': {
      display: 'none',
    },
  },
};
